import Vue from 'vue'

export const projectService = {
  get,
  create,
  fetch,
  fetchTypes,
  fetchPaymentInfos,
  fetchPaymentInfoTypes,
  fetchItems,
  fetchAddons,
  fetchForUser,
  fetchOrganisatorsForUser,
  fetchStatsForUser,
  fetchOfUser,
  fetchAllParticipants,
  fetchParticipants,
  fetchPickupPoints,
  fetchDistribution,
  fetchDistributionEdit,
  fetchDistributionLoose,
  fetchUpdates,
  fetchComments,
  updatePickup,
  updateItems,
  updateAddons,
  updateProject,
  postUpdate,
  postPaymentInfo,
  postItem,
  postAddon,
  postComment,
  postPaymentParticipant,
  postPickupPoint,
  deleteUpdate,
  deletePaymentInfo,
  deleteItem,
  deleteAddon,
  deletePickupPoint,
  lockAddons,
  unlockAddons,
  delivered,
  userDelivered,
  userDeliveredSelf,
  allowShipping,
  disallowShipping,
  lockDistribution,
  unsubscribe,
  requestApproval,
  approve,
  sendFeedback,
  cancelProject
}

function get (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project/' + id))
      .then(response => {
        let project = response.data.data
        processProject(project)
        resolve(project)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function create (project) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-create'), project)
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetch (filter) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project'), filter)
      .then(response => {
        let projects = response.data.data
        projects.forEach(function (project) {
          processProject(project)
        })
        resolve(projects)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchTypes () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-type'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchPaymentInfos (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-payment-info/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchPaymentInfoTypes () {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-payment-info-type'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchItems (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-item/' + id))
      .then(response => {
        let items = response.data.data
        items.forEach(function (item) {
          processItem(item)
        })
        resolve(items)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchAddons (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon/' + id))
      .then(response => {
        let addons = response.data.data
        addons.forEach(function (addon) {
          processAddon(addon)
        })
        resolve(addons)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchForUser (id, filter) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-user/' + id), filter)
      .then(response => {
        let projects = response.data.data
        projects.forEach(function (project) {
          processProject(project)
        })
        resolve(projects)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchOrganisatorsForUser (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-organisator-user/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchStatsForUser (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-stats-user/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchOfUser (id, filter) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-created-user/' + id), filter)
      .then(response => {
        let projects = response.data.data
        projects.forEach(function (project) {
          processProject(project)
        })
        resolve(projects)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchAllParticipants (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-participant'))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchParticipants (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-participant/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchPickupPoints (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-pickup/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchDistribution (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-distribution/' + id))
      .then(response => {
        let distribution = response.data.data
        if (distribution) {
          processDistribution(distribution)
        }
        resolve(distribution)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchDistributionEdit (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-distribution-edit/' + id))
      .then(response => {
        let distribution = response.data.data
        if (distribution) {
          processDistribution(distribution)
        }
        resolve(distribution)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchDistributionLoose (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-distribution-loose/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchUpdates (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-update/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function fetchComments (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.get(Vue.prototype.$hostname.concat('/api/crowdfinder/project-comment/' + id))
      .then(response => {
        resolve(response.data.data)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updatePickup (id, pickup) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-pickup/' + id), pickup)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updateItems (id, items) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-item' + (process.env.NODE_ENV !== 'production' ? '-local' : '') + '/' + id), items)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updateAddons (id, addons) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon/' + id), addons)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function updateProject (id, data) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-edit/' + id), data)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postUpdate (id, update) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-update/' + id), update)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postPaymentInfo (id, paymentInfo) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-payment-info/' + id), paymentInfo)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postItem (id, item) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-item-edit/' + id), item)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postAddon (id, addon) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon-edit/' + id), addon)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postComment (id, comment) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-comment/' + id), { 'text': comment })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postPaymentParticipant (id, paymentParticipant) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-participant-payment/' + id), paymentParticipant)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function postPickupPoint (id, pickupPoint) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-pickup-point/' + id), pickupPoint)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function deleteUpdate (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.delete(Vue.prototype.$hostname.concat('/api/crowdfinder/project-update/' + id))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function deletePaymentInfo (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.delete(Vue.prototype.$hostname.concat('/api/crowdfinder/project-payment-info/' + id))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function deleteItem (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.delete(Vue.prototype.$hostname.concat('/api/crowdfinder/project-item-edit/' + id))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function deleteAddon (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.delete(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon-edit/' + id))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function deletePickupPoint (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.delete(Vue.prototype.$hostname.concat('/api/crowdfinder/project-pickup-point/' + id))
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function lockAddons (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon-lock/' + id), { 'locked': true })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function unlockAddons (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-addon-lock/' + id), { 'locked': false })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function delivered (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-delivered/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function userDelivered (id, user) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-distribution-edit/' + id), user)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function userDeliveredSelf (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-user-delivered/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function allowShipping (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-shipping/' + id), { 'allowed': true })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function disallowShipping (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-shipping/' + id), { 'allowed': false })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function lockDistribution (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-distribution-lock/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function unsubscribe (id, userId) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-unsubscribe/' + id), { 'user_id': userId })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function requestApproval (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-request-approval/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function approve (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-approved/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function sendFeedback (id, feedback) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-feedback/' + id), { 'feedback': feedback })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function cancelProject (id) {
  return new Promise((resolve, reject) => {
    Vue.prototype.$http.post(Vue.prototype.$hostname.concat('/api/crowdfinder/project-cancel/' + id), {})
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

function processProject (project) {
  project.image = Vue.prototype.$hostname.concat('/image/project/').concat(project.id).concat('/').concat(project.image)
  if (project.store_logo) {
    project.store_logo = Vue.prototype.$hostname.concat('/image/user/').concat(project.user_id).concat('/logo/').concat(project.store_logo)
  }
  project.new_total_price = parseFloat(Vue.options.filters.round(project.new_price + (project.new_shipping_known ? project.new_shipping : 0), 2))
  project.normal_total_price = parseFloat(Vue.options.filters.round(project.normal_price + (project.normal_shipping_known ? project.normal_shipping : 0), 2))
  project.discount = project.normal_total_price > 0 ? parseInt(Vue.options.filters.round(+(Math.round((1 - (project.new_total_price / project.normal_total_price)) + 'e+2') + 'e-2') * 100, 0)) : 0
}

function processItem (item) {
  item.new_total_price = parseFloat(Vue.options.filters.round(item.new_price + (item.new_shipping_known ? item.new_shipping : 0), 2))
  item.normal_total_price = parseFloat(Vue.options.filters.round(item.normal_price + (item.normal_shipping_known ? item.normal_shipping : 0), 2))
  item.discount = item.normal_total_price > 0 ? parseInt(Vue.options.filters.round(+(Math.round((1 - (item.new_total_price / item.normal_total_price)) + 'e+2') + 'e-2') * 100, 0)) : 0
}

function processAddon (addon) {
  addon.total_price = parseFloat(Vue.options.filters.round(addon.price + (addon.shipping_known ? addon.shipping : 0), 2))
}

function processDistribution (distribution) {
  processPickups(distribution.pickups, distribution.id)
  processShipments(distribution.shipments)
}

function processPickups (pickups, userId) {
  if (pickups && pickups.length > 0) {
    pickups.forEach(function (pickup) {
      if (pickup.city && pickup.country) {
        processPickupPoint(pickup)
      } else {
        processParticipant(pickup, 'user', userId)
      }
    })
  }
}

function processShipments (shipments) {
  if (shipments && shipments.length > 0) {
    shipments.forEach(function (shipment) {
      processParticipant(shipment, 'send', null)
    })
  }
}

function processPickupPoint (pickupPoint) {
  if (pickupPoint.users && pickupPoint.users.length > 0) {
    pickupPoint.users.forEach(function (participant) {
      processParticipant(participant, 'pickup', pickupPoint.id)
    })
  }
}

function processParticipant (participant, type, id) {
  participant.pickup = {
    'type': type,
    'id': id
  }
  processPickups(participant.pickups, participant.id)
}

/* function convertRate (project) {
  return new Promise((resolve, reject) => {
    processRate(project, resolve, reject)
  })
}

function convertRates (projects) {
  return new Promise((resolve, reject) => {
    projects.forEach(function (project) {
      processRate(project, resolve, reject)
    })
  })
}

function processRate (project, resolve, reject) {
  project.rate = 1
  project.showRate = false
  currencyService.fetch(project.currency)
    .then((rate) => {
      project.rate = rate
      project.showRate = true
    }, (error) => {
      project.rate = null
      reject(error)
    })
} */



// WEBPACK FOOTER //
// ./src/services/project.service.js